// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"LoadingOverlay_loadingContainer__Iaejz","spinner":"LoadingOverlay_spinner__U7VvD","spinnerLoading":"LoadingOverlay_spinnerLoading__k_yeA"};